import _ from 'lodash';

import SharedConfig from './config';

function getRewardForTitle(title, isStripe) {
  if (_.isUndefined(isStripe)) {
    throw new Error('getRewardForTitle requires isStripe parameter');
  }

  const { userLevels } = SharedConfig;
  let reward = { ...userLevels.default };

  if (title) {
    const titleLower = _.replace(title.toLowerCase(), ' ', '');
    if (userLevels[titleLower]) {
      reward = { ...userLevels[titleLower] };
    }
  }

  if (isStripe) {
    const multiplier = 1.1;
    reward.iterationsLimit = reward.stripeIterationsLimit
      || 10000 * Math.round((reward.iterationsLimit * multiplier) / 10000);
  }

  return reward;
}

function getRewardsForUser(user) {
  const isStripe = _.get(user, 'stripeLinked', false)
    || _.get(user, 'stripe.customer.id', false)
    || _.get(user, 'skipPatreon', false);

  // not logged in
  if (!user || !user.username) {
    return getRewardForTitle('default', false);
  }
  // logged in, non patron
  if (!user.patreonTitle) {
    return getRewardForTitle('registered', false);
  }

  return getRewardForTitle(user.patreonTitle, isStripe);
}

export default {
  getRewardForTitle,
  getRewardsForUser,
};
